<template>
  <DialogHeader>
    <template #right>
      <div class="text-green-900 cursor-pointer" @click="close()">Close</div>
    </template>
    Your plan details
  </DialogHeader>
  <DialogContent>
    <div
      class="w-full bg-gray-800/5 rounded-[10px] p-3 tablet-h:px-[25px] tablet-h:py-[23px]"
    >
      <div
        v-for="(price, index) in props.prices"
        :key="`price-${index}`"
        class="mb-1.5 w-full flex items-center justify-between leading-[22px]"
      >
        <div class="mr-3">{{ price.description }}</div>
        <div class="text-right">
          <template v-if="price.details.amount">
            {{ formatPriceDetails(price.details) }}
          </template>
          {{ price.details.suffix }}
        </div>
      </div>
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import type {
  BillingPrice,
  BillingPriceDetail,
} from '@/shared/graphql/legacy/generated'
import { formatPrice } from '@/shared/utils/money'

const { close } = useDialog()

const props = defineProps<{
  prices: BillingPrice[]
}>()

const formatPriceDetails = (price: BillingPriceDetail) => {
  return formatPrice({
    amount: (price.amount || 0) / 100,
    currency: price.currency,
  })
}
</script>
